export default {
  userID(state) {
    return state.userID;
  },
  isLoggedIn(state) {
    return (
      (state.token !== null && state.token !== '' && state.token !== 'null') ||
      (localStorage.getItem('token') !== '' && localStorage.getItem('login_type') == 'teacher')
    );
  },
  token(state) {
    return localStorage.getItem('login_type') === 'teacher' && localStorage.getItem('token') !== ''
      ? localStorage.getItem('token')
      : state.token;
  },
  teacherName(state) {
    return state.fname + ' ' + state.lname;
  },
  fName(state) {
    return state.fname;
  },
  lName(state) {
    return state.lname;
  },
  email(state) {
    return state.email;
  },
  school(state) {
    return state.school;
  },
  experience(state) {
    return state.experience;
  },
  accessType(state) {
    console.log(state);
    return state.access_type;
  },
  notifications(state) {
    return state.notifications;
  },
};
